import { Routes, Route, Navigate } from 'react-router-dom';
import { ConvexClientProvider } from '@/components/providers/ConvexClientProvider';
import { LayoutWrapper } from '@/components/layout/LayoutWrapper';
import { useAuth } from '@/contexts/AuthContext';

// Pages
import HomePage from '@/pages/HomePage';
import AuthPage from '@/pages/AuthPage';
import ProfilePage from '@/pages/ProfilePage';
import ChatPage from '@/pages/ChatPage';
import ChatDetailPage from '@/pages/ChatDetailPage';
import CandidatesPage from '@/pages/CandidatesPage';
import RegisterPage from '@/pages/RegisterPage';
import RegisterSeekerPage from '@/pages/RegisterSeekerPage';
import RegisterCompanyPage from '@/pages/RegisterCompanyPage';

// Protected Route Component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        style={{ backgroundColor: 'var(--color-bg-primary)' }}
      >
        <p style={{ color: 'var(--color-text-secondary)' }}>Laster...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <ConvexClientProvider>
      <LayoutWrapper>
        <Routes>
          {/* Public routes */}
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register/seeker" element={<RegisterSeekerPage />} />
          <Route path="/register/company" element={<RegisterCompanyPage />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          {/* Redirect /matches to /chat (merged functionality) */}
          <Route path="/matches" element={<Navigate to="/chat" replace />} />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/:matchId"
            element={
              <ProtectedRoute>
                <ChatDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/candidates"
            element={
              <ProtectedRoute>
                <CandidatesPage />
              </ProtectedRoute>
            }
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </LayoutWrapper>
    </ConvexClientProvider>
  );
}

